import { useEffect } from "react";
import CoralvilleHeroSection from "./components/HeroSection";
import CoralvilleStickyNav from "./components/StickyNav";
import CoralvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import CoralvilleServicesSection from "./components/ServicesSection";
import CoralvilleLocalAreaSection from "./components/LocalAreaSection";
import CoralvilleTestimonialsSection from "./components/TestimonialsSection";
import CoralvilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import CoralvilleComparisonSection from "./components/ComparisonSection";
import CoralvilleMistakesSection from "./components/MistakesSection";
import CoralvilleHowItWorksSection from "./components/HowItWorksSection";
import CoralvilleFAQSection, { faqs } from "./components/FAQSection";
import CoralvilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import CoralvilleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function CoralvillePage() {
  useEffect(() => {
    document.title = "Emergency Passport Coralville IA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("name", name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/coralville/";

    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Coralville, IA — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Iowa River Landing professionals, UIowa travelers, and Johnson County families.");
    setMeta("geo.placename", "Coralville, Iowa");
    setMeta("geo.region", "US-IA");
    setMeta("geo.position", "41.6764;-91.5807");
    setMeta("ICBM", "41.6764, -91.5807");

    const graph = [
      {
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
          { "@type": "ListItem", position: 2, name: "Iowa", item: "https://fastpassportcenter.com/iowa/" },
          { "@type": "ListItem", position: 3, name: "Coralville Passport Services", item: pageUrl },
        ],
      },
      {
        "@type": "LocalBusiness",
        name: "Fast Passport Center",
        description: "Emergency and expedited passport services for Coralville, Iowa River Landing professionals, and Johnson County. As fast as 24 hours.",
        url: pageUrl,
        telephone: "+1-877-253-0084",
        areaServed: { "@type": "City", name: "Coralville", containedInPlace: { "@type": "State", name: "Iowa" } },
        priceRange: "$$$",
        openingHours: ["Mo-Fr 09:00-18:00"],
        aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" },
      },
      {
        "@type": "FAQPage",
        mainEntity: faqs.map((faq) => ({
          "@type": "Question",
          name: faq.q,
          acceptedAnswer: { "@type": "Answer", text: faq.a },
        })),
      },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data";
    document.getElementById("structured-data")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data")?.remove();
      document.querySelector('link[rel="canonical"]')?.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <CoralvilleHeroSection />
      <CoralvilleStickyNav />
      <CoralvilleProcessingTimeSection />
      <CoralvilleServicesSection />
      <CoralvilleLocalAreaSection />
      <CoralvilleTestimonialsSection />
      <CoralvilleAcceptanceFacilitiesSection />
      <CoralvilleComparisonSection />
      <CoralvilleMistakesSection />
      <CoralvilleHowItWorksSection />
      <CoralvilleFAQSection />
      <CoralvilleHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/coralville" state="IA" />
      <CoralvilleFinalCTA />
    </div>
  );
}